
const ImageLoader = (image) => {


    return  <img alt={"Loading..."} className={"new-button-size"} src={`${process.env.REACT_APP_APP_URL}/ic/${image}`}/>

}

export default ImageLoader
